import { Avatar, Typography, Divider, Stack, Box } from '@mui/material';

import { KeyBadge } from '@/components/KeyBadge/KeyBadge';
import { graphql, type DocumentType } from '@/gql';
import { Or2LinkButton } from '@/components/button/Or2LinkButton';

const POST_OWNER_BAR_POST_FRAGMENT = graphql(`
  fragment postOwnerBarPostFragment on Post {
    _id
    owner {
      _id
      machineName
      name
      iconUrl
      hasKsg
    }
  }
`);

interface Props {
  post: DocumentType<typeof POST_OWNER_BAR_POST_FRAGMENT>;
}

export const PostOwnerBar = ({ post }: Props) => {
  const { owner } = post;
  const { machineName, name, hasKsg, iconUrl } = owner ?? {};

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{ paddingX: 2, paddingY: 1 }}
      >
        <KeyBadge hasKsg={hasKsg || false} keyAvatarProps={{ size: 15 }}>
          <Avatar
            src={iconUrl ?? ''}
            alt={name ?? ''}
            sx={(theme) => ({
              width: theme.spacing(4),
              height: theme.spacing(4),
            })}
          >
            {name?.charAt(0)}
          </Avatar>
        </KeyBadge>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <Typography variant="subtitle2" color="textSecondary">
            Posted by
          </Typography>
          <Or2LinkButton
            href={`/g/${machineName}/noticeboard`}
            size="small"
            color="primary"
            variant="text"
            sx={{ padding: 0, marginLeft: 0.6 }}
          >
            {name}
          </Or2LinkButton>
        </Box>
      </Stack>
      <Divider />
    </>
  );
};
